import { Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const HeaderContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(10),
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const MergePatientsModalHeader = () => {
  return (
    <HeaderContainer>
      <StyledTypography variant={'h4'}>Merge duplicate patient profiles</StyledTypography>
    </HeaderContainer>
  );
};
